export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0D1B2A] mx-5 mb-5 rounded-2xl relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-24 py-20">
        <div className="grid grid-cols-4 gap-16 relative z-10">
          <div>
            <div className="flex items-center gap-3 mb-10">
              <img
                src="https://public.readdy.ai/ai/img_res/9d69b025-498f-41a7-adf2-7170783fc8ba.png"
                alt="BRIMA Logo"
                className="h-10 w-auto"
              />
              <span className="text-white text-[36px] font-bold">BRIMA</span>
            </div>
            <p className="text-gray-400 text-base leading-[1.8]">
              Securing digital freedom<br />
              through advanced VPN<br />
              technology solutions
            </p>
          </div>

          <div>
            <h4 className="text-white text-lg font-medium mb-6">NAVIGATION</h4>
            <div className="space-y-5">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('vpn-service')}
                className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer text-left"
              >
                About Us
              </button>
              <button
                onClick={() => scrollToSection('support')}
                className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer text-left"
              >
                Security
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer text-left"
              >
                Contact
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-white text-lg font-medium mb-6">RESOURCES</h4>
            <div className="space-y-5">
              <a href="#" className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="#" className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer">
                Documentation
              </a>
              <a href="#" className="block text-gray-400 text-base hover:text-white transition-colors cursor-pointer">
                Support Center
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-lg font-medium mb-4">STAY UPDATED</h4>
            <p className="text-gray-400 text-sm leading-[1.6] mb-8">
              Subscribe for security updates<br />
              and product announcements
            </p>
            <div className="flex items-center gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-5 py-3 bg-[#1A2332] border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent"
              />
              <button className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors flex-shrink-0 cursor-pointer">
                <i className="ri-arrow-right-line text-xl text-[#0D1B2A]"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 text-[180px] font-bold text-[#151F2E] opacity-30 leading-none pointer-events-none">
          BRIMA
        </div>

        <div className="mt-16 pt-10 border-t border-white/20 relative z-10">
          <div className="flex items-center justify-between">
            <p className="text-gray-400 text-xs">
              © 2025 BRIMA SERVICOS DE COBRANCA LTDA. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
